import {useAppDispatch, useAppSelector} from '@/hooks/redux'
import {selectUser} from '@/store/selectors'
import {Stack, Typography} from '@mui/material'
import {colors} from '@/constants'
import React, {useState} from 'react'
import Input from '@/components/UI/input/Input'
import HoverButton from '@/components/UI/button/HoverButton'
import {ReactComponent as CopyIcon} from '@/assets/svgs/CopyIcon.svg'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import QuestionTooltip from '@/components/UI/questionTooltip'
import useFetching from '@/hooks/useFetching'
import UserService from '@/services/api/User'
import {updateUser} from '@/store/actions'
import {useTranslation} from 'react-i18next'
import TransCustom from '@/components/UI/i18next'

const Index = () => {
  const user = useAppSelector(selectUser)
  const dispatch = useAppDispatch()
  const {t} = useTranslation()
  const {copyToClipboard} = useCopyToClipboard()
  const [referralLink, setReferralLink] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string>('')

  const [editProfile] = useFetching(async (data) => {
    UserService.editProfile(data)
      .then((res) => {
        if (res.status === 200) {
          dispatch(updateUser())
        }
      })
      .catch((e) => {
        if (e?.response?.data) {
          if (e.response.data.context[0]) {
            setErrorMessage(e.response.data.context[0].msg)
          }
        }
      })
  })

  return (
    <Stack
      style={{wordBreak: 'break-word'}}
      width="80%"
      height="100%"
      className="events-block"
      paddingRight="20px"
      gap="70px">
      <Typography
        color={colors.yellow}
        fontWeight="600"
        fontSize="40px"
        lineHeight="1">
        Antallagi.io
      </Typography>
      {user!.referral_link ? (
        <>
          <Stack direction="row">
            <Stack direction="row">
              <TransCustom fontSize="20px" i18nKey="1381" />
              <Typography fontSize="20px">: {user!.referral_link}</Typography>
              <CopyIcon
                className="svg-first-color-fill pointer"
                style={{marginLeft: '5px'}}
                onClick={() => copyToClipboard(user!.referral_link || '')}
              />
            </Stack>
          </Stack>
          <Stack position="relative" width="fit-content">
            <Stack
              style={{opacity: '0.3'}}
              padding="10px"
              borderRadius="5px"
              border={`1px solid ${colors.gray}`}>
              <TransCustom i18nKey="1382" variant="body2" color={colors.gray} />
            </Stack>
            <QuestionTooltip id="dashboard-2" styles={{maxWidth: '500px'}}>
              <TransCustom i18nKey="1308" variant="body2" />
            </QuestionTooltip>
          </Stack>
        </>
      ) : (
        <Stack width="100%" alignItems="center">
          <Stack
            width="600px"
            gap="60px"
            justifyContent="center"
            alignItems="center">
            <Stack position="relative" width="100%">
              <Input
                fullWidth
                textalign="center"
                placeholderalign="center"
                placeholder={
                  t('1167') || 'Enter your Antallagí.io referral number'
                }
                variant="standard"
                color="warning"
                onChange={(e) => {
                  if (errorMessage.length > 0) {
                    setErrorMessage('')
                  }
                  setReferralLink(e.target.value)
                }}
              />
              {errorMessage.length > 0 && (
                <Typography
                  top="50px"
                  fontSize="12px"
                  color={colors.alert}
                  position="absolute">
                  {errorMessage}
                </Typography>
              )}
            </Stack>
            <Stack gap="20px" maxWidth="626px">
              <TransCustom i18nKey="1168" variant="body2" />
              <TransCustom i18nKey="1169" variant="body2" />
            </Stack>
            <HoverButton
              width="314px"
              height="38px"
              fontSize="16px"
              disabled={referralLink === ''}
              onClick={() => editProfile({referral_link: referralLink})}>
              Confirm
            </HoverButton>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}

export default Index
